package org.hs_soft.runmynesto.domain.model.home.customer_card.loyalty_card


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListLoyaltyCards(
    @SerialName("cursors")
    val cursors: Cursors?,
    @SerialName("hasNextPage")
    val hasNextPage: Boolean?,
    @SerialName("items")
    val loyaltyCardItems: List<LoyaltyCardItem?>?,
    @SerialName("total")
    val total: Int?,
    @SerialName("__typename")
    val typename: String?
)